export const calculatePercentage = (total, value) => {
  return ((value / total) * 100).toFixed(2)
};

export const calculateTotal = (data, name) => {
  return data.reduce((total, currentValue) => total + currentValue[name], 0)
};






